import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IntroSection } from '../components/IntroSection';
import { NewsletterSection } from '../components/NewsletterSection';
import { Button } from '../components/ui/Button';
import { Brain, Heart, Sparkles, Calendar, MessageSquare, Footprints } from 'lucide-react';
import { navigate, BOOKING_URL } from '../lib/navigation';
export function Home() {
  const steps = [{
    icon: <Calendar className="w-6 h-6" data-id="element-271" />,
    title: 'Book a free consultation',
    desc: "A 15-minute video call to see if we're a good fit"
  }, {
    icon: <MessageSquare className="w-6 h-6" data-id="element-272" />,
    title: "We'll talk about it",
    desc: "Share what you're going through, no pressure"
  }, {
    icon: <Footprints className="w-6 h-6" data-id="element-273" />,
    title: 'Start arriving at yourself',
    desc: 'Begin building a life that actually feels like yours'
  }];
  return <div className="animate-fade-in-up" data-id="element-274">
      <HeroSection data-id="element-275" />
      <IntroSection data-id="element-276" />

      {/* Combined: How We Work + Getting Started */}
      <section className="py-20 md:py-32 bg-sage/10" data-id="element-277">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-279">
            <h2 className="text-3xl md:text-4xl font-medium text-teal mb-4" data-id="element-280">
              How we'll work together
            </h2>
            <p className="text-xl text-teal/70" data-id="element-281">
              Evidence-based approaches to help you arrive at yourself
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-282">
            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group cursor-pointer" onClick={() => navigate('#/services')} data-id="element-283">
              <div className="w-12 h-12 bg-sage/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-sage/30 transition-colors" data-id="element-284">
                <Brain className="w-6 h-6 text-sage" data-id="element-285" />
              </div>
              <h3 className="text-xl font-semibold text-teal mb-4" data-id="element-286">
                My Approach
              </h3>
              <p className="text-teal/80" data-id="element-287">
                I use CBT, DBT, mindfulness-based therapy, and narrative therapy
                to find what works for you.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group cursor-pointer" onClick={() => navigate('#/services')} data-id="element-288">
              <div className="w-12 h-12 bg-terracotta/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-terracotta/30 transition-colors" data-id="element-289">
                <Heart className="w-6 h-6 text-terracotta" data-id="element-290" />
              </div>
              <h3 className="text-xl font-semibold text-teal mb-4" data-id="element-291">
                Focus Areas
              </h3>
              <p className="text-teal/80" data-id="element-292">
                Specialising in anxiety, OCD, life transitions, and breaking
                people-pleasing patterns.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group cursor-pointer" onClick={() => navigate('#/services')} data-id="element-293">
              <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-teal/20 transition-colors" data-id="element-294">
                <Sparkles className="w-6 h-6 text-teal" data-id="element-295" />
              </div>
              <h3 className="text-xl font-semibold text-teal mb-4" data-id="element-296">
                Expectations
              </h3>
              <p className="text-teal/80" data-id="element-297">
                Real conversations, evidence-based tools, and a judgement-free
                space to be yourself.
              </p>
            </div>
          </div>

          {/* Getting Started Steps */}
          <div className="max-w-3xl mx-auto" data-id="element-298">
            <div className="text-center mb-12" data-id="element-299">
              <h3 className="text-2xl md:text-3xl font-medium text-teal mb-3" data-id="element-300">
                Ready to start?
              </h3>
              <p className="text-lg text-teal/70" data-id="element-301">
                Three simple steps to begin your journey
              </p>
            </div>

            <div className="space-y-8 mb-12" data-id="element-302">
              {steps.map((step, index) => <div key={index} className="flex items-start gap-6" data-id="element-303">
                  <div className="relative flex-shrink-0" data-id="element-304">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm border-2 border-sage/10" data-id="element-305">
                      <div className="text-terracotta" data-id="element-306">{step.icon}</div>
                    </div>
                    <div className="absolute -top-1 -right-1 w-7 h-7 bg-terracotta rounded-full flex items-center justify-center text-white font-bold text-xs" data-id="element-307">
                      {index + 1}
                    </div>
                    {index < steps.length - 1 && <div className="absolute top-16 left-1/2 -translate-x-1/2 w-0.5 h-8 bg-sage/20" data-id="element-308" />}
                  </div>
                  <div className="pt-2" data-id="element-309">
                    <h4 className="text-xl font-semibold text-teal mb-1" data-id="element-310">
                      {step.title}
                    </h4>
                    <p className="text-teal/70" data-id="element-311">{step.desc}</p>
                  </div>
                </div>)}
            </div>

            <div className="text-center" data-id="element-312">
              <Button size="lg" onClick={() => window.open(BOOKING_URL, '_blank')} data-id="element-313">
                Book Your Free Consultation
              </Button>
            </div>
          </div>
        </div>
      </section>

      <NewsletterSection data-id="element-314" />
    </div>;
}